import { useEffect, useRef } from "react";
import { acquireLock, releaseLock } from "../configure/concurrencyLock";

// 1 sec checks
const IDLE_CHECK_INTERVAL = 1000;

const IDLE_WARNING_TIME = 25 * 60 * 1000; // 25 min
const IDLE_EXPIRATION_TIME = 30 * 60 * 1000; // 30 min
// const IDLE_WARNING_TIME = 5 * 60 * 1000; // 5 min
// const IDLE_EXPIRATION_TIME = 10 * 60 * 1000; // 10 min
const GLOBAL_IDLE_KEY = "SANDEE_GLOBAL_IDLE_STATE";

export function useIdleTimer(onWarning, onExpire, onActiveUpdate) {
  const timerRef = useRef(null);

  useEffect(() => {
    const events = ["click", "keydown", "touchstart", "mousemove"];

    const handleActivity = () => {
      onActiveUpdate?.();
    };

    events.forEach((evt) => window.addEventListener(evt, handleActivity));

    timerRef.current = setInterval(checkIdle, IDLE_CHECK_INTERVAL);
    window.addEventListener("storage", onStorageChange);

    return () => {
      events.forEach((evt) => window.removeEventListener(evt, handleActivity));
      clearInterval(timerRef.current);
      window.removeEventListener("storage", onStorageChange);
    };
  }, [onWarning, onExpire, onActiveUpdate]);

  function onStorageChange(e) {
    if (e.key === GLOBAL_IDLE_KEY && e.newValue) {
      const globalState = JSON.parse(e.newValue);
      if (globalState.isExpired) {
        onExpire?.();
      }
    }
  }

  function checkIdle() {
    const now = Date.now();
    const globalState = getGlobalIdleState();
    if (!globalState) return;

    const idleTime = now - globalState.lastActive;

    if (idleTime >= IDLE_EXPIRATION_TIME) {
      if (!globalState.isExpired) {
        if (acquireLock("SANDEE_EXPIRE_LOCK")) {
          try {
            const updated = { ...globalState, isExpired: true };
            localStorage.setItem(GLOBAL_IDLE_KEY, JSON.stringify(updated));
            broadcastChange(updated);
            onExpire?.();
          } finally {
            releaseLock("SANDEE_EXPIRE_LOCK");
          }
        }
      }
    } else if (idleTime >= IDLE_WARNING_TIME) {
      onWarning?.(IDLE_EXPIRATION_TIME - idleTime);
      //   if (!globalState.warningShown) {
      //     // optional lock if you want only ONE tab to show the warning
      //     if (acquireLock("SANDEE_WARNING_LOCK")) {
      //       try {
      //         onWarning?.(IDLE_EXPIRATION_TIME - idleTime);
      //         const updated = { ...globalState, warningShown: true };
      //         localStorage.setItem(GLOBAL_IDLE_KEY, JSON.stringify(updated));
      //         broadcastChange(updated);
      //       } finally {
      //         releaseLock("SANDEE_WARNING_LOCK");
      //       }
      //     }
      //   }
    }
  }

  return null;
}

export function updateLastActive(forceNotExpired = false) {
  const now = Date.now();
  const globalState = getGlobalIdleState() || { lastActive: now, isExpired: false };
  const updated = {
    ...globalState,
    lastActive: now,
    isExpired: forceNotExpired ? false : globalState.isExpired,
  };
  localStorage.setItem(GLOBAL_IDLE_KEY, JSON.stringify(updated));
  broadcastChange(updated);
}

function broadcastChange(payload) {
  if (typeof BroadcastChannel !== "undefined") {
    const bc = new BroadcastChannel("IDLE_CHANNEL");
    bc.postMessage({ type: "IDLE_UPDATE", payload });
    bc.close();
  }
}

function getGlobalIdleState() {
  const data = localStorage.getItem(GLOBAL_IDLE_KEY);
  return data ? JSON.parse(data) : null;
}
